// extracted by mini-css-extract-plugin
export default {"retailOutlets":"retailOutlets_retailOutlets__Dwq43"};